import { makeStyles } from '@mui/styles';
// colors
import { colors } from '../../../packages';

export const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: 40,
  },
  cardContentSection: {
    display: 'flex',
    justifyContent: 'space-around',
    flexDirection: 'row',
    columnGap: 95,
    padding: 24,
    backgroundColor: '#FFF',
    borderRadius: 8,
    height: 296,
    boxShadow:
      '0px 4px 8px rgba(0, 0, 0, 0.04), 0px 0px 2px rgba(0, 0, 0, 0.06), 0px 0px 1px rgba(0, 0, 0, 0.04)',
  },
  ranksList: {
    display: 'flex',
    flexDirection: 'column',
    padding: '60px 0px 25px 48px',
    gap: 35,
  },
  rank: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 20,
  },
  rankPill: {
    width: '24px !important',
    height: '24px !important',
  },
  sessionList: {
    display: 'flex',
    flexDirection: 'column',
    gap: 30,
  },
  providersList: {
    display: 'flex',
    flexDirection: 'column',
  },
  provider: {
    display: 'flex',
    flexDirection: 'column',
    gap: 15,
  },
  rankFont: {
    fontFamily: 'Manrope',
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '20px',
  },
  providerHeadingFont: {
    fontFamily: 'Manrope',
    fontWeight: 600,
    fontSize: 18,
    lineHeight: '24px',
  },
  member: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
  },
  info: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0,
  },
  table: {
    backgroundColor: colors.white,
    overflowX: 'hidden',
  },
  badge: {
    borderRadius: 20,
    height: 18,
    padding: '2px 8px',
    fontSize: 12,
    width: 'fit-content',
    border: 'none',
    marginTop: 2,
    textWrap: 'nowrap',
  },
  heading: {
    fontFamily: 'Source Serif Pro',
    margin: 0,
  },
  status: {
    height: 22,
    width: 86,
    padding: 0,
    borderRadius: 20,
    fontSize: 12,
    fontWeight: 600,
  },
  dot: {
    width: 6,
    height: 6,
    borderRadius: '50%',
    marginRight: 6,
    display: 'inline-block',
    backgroundColor: colors.neutral600,
  },
  dotActive: {
    backgroundColor: colors.green600,
  },
  menu: {
    float: 'right',
    right: 20,
    '& svg': {
      width: 16,
    },
  },
  menuItemsWrapper: {
    '& ul': {
      padding: 0,
    },
    '& ul li': {
      padding: '10px 16px',
    },
  },
  totalMemberBadge: {
    borderRadius: 99,
    whiteSpace: 'nowrap',
    height: 30,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 12px',
    color: colors.neutral700,
  },
  addBtn: {
    height: 64,
    width: 178,
    color: '#FFF',
    whiteSpace: 'nowrap',
    padding: '20px 24px',
    borderRadius: 8,
  },
  memberColumn: {
    textDecoration: 'none',
    fontFamily: 'Manrope',
    fontWeight: 600,
    fontSize: 14,
    lineHeight: '19px',
    color: colors.primary600,
  },
});
